module.exports = __webpack_public_path__ + "img/Liechtenstein.5ee81330.svg";